module.exports = {
  props: ['user', 'range', 'pipeline', 'interval', 'pngSrc', 'displaySvg'],

  created () {
    this.get();
  },

  mounted () {
    Bus.$on('selectedDealsTypes', (selectedDealsTypes) => {
      this.selectedDealsTypes = selectedDealsTypes
    });
    Bus.$on('resetSelectedDealsTypes', () => this.resetData());

    this.$watch('user', () => this.get());
    this.$watch('range', () => this.get());
    this.$watch('pipeline', () => this.get());
    this.$watch('selectedDealsTypes', () => this.updateData());
  },

  beforeDestroy() {
    Bus.$off('selectedDealsTypes');
    Bus.$off('resetSelectedDealsTypes');
  },

  data () {
    return {
      loading: false,
      data: {},
      selectedDealsTypes: ["deals.started", "deals.closed", "deals.lost"],
      allDealsTypes: ["deals.started", "deals.closed", "deals.lost"],
      containerCol: 'col-4',
      originalFetchedData: {},
    };
  },

  methods: {
    setOriginalFetchedData(fetchedData) {
      this.originalFetchedData = fetchedData;
    },

    waitForChartToBeRendered () {
      return new Promise((resolve) => {
        let intervalId;

        intervalId = setInterval(() => {
          if (this.loading === false) {
            console.log(`Chart ${this.name} has already finished loading`);

            clearInterval(intervalId);
            return resolve(true);
          }

          console.log(`Waiting for ${this.name} chart to be rendered`);
        }, 1000)
      });
    },

    updateData() {
      this.allDealsTypes.forEach((dealsType) => {
        if (!this.selectedDealsTypes.includes(dealsType)) {
          delete this.data[dealsType.split('.').pop()];;
        }
      })

      this.containerCol = `col-${12/Object.keys(this.selectedDealsTypes).length}`;
    },

    async resetData() {
      Object.assign(this.data, this.originalFetchedData);
      this.$forceUpdate();
      this.selectedDealsTypes = this.allDealsTypes;
    },

    async get () {
      this.loading = true;

      const params = {
        user: this.user,
        range: this.range,
        pipeline: this.pipeline,
        interval: this.interval,
      };

      this.$http.get('/widget/deals', { params })
        .then((response) => {
          this.setOriginalFetchedData({...response.data});
          this.data = response.data;

          const svgIds = [
            "started", "closed", "lost"
          ];

          svgIds.forEach((svgId) =>
            this.data[svgId].svgId = svgId
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
